import * as filterActions from '../actions/filter.actions';
import { createEntityAdapter } from '@ngrx/entity';
import { EntityState } from '@ngrx/entity';
import { RuleSet } from 'ngx-angular-query-builder';
import {ListType} from "@common/enums/list-type";

abstract class FilterInstance {
  filter: RuleSet;
  loading: boolean;
  error: any;
}

export class WidgetFilterInstance extends FilterInstance {
  widgetId: number;
}

export const widgetFiltersAdapter =
  createEntityAdapter<WidgetFilterInstance>({selectId:x => x.widgetId});
export interface WidgetFilterState extends EntityState<WidgetFilterInstance> { }
export const INITIAL_WIDGET_FILTER_STATE: WidgetFilterState = widgetFiltersAdapter.getInitialState({});

export function widgetFilterReducer(state: WidgetFilterState = INITIAL_WIDGET_FILTER_STATE,
                                    action: filterActions.WidgetFilterActions) {

  switch (action.type) {
    case filterActions.UPDATE_WIDGET_FILTER:
    case filterActions.LOAD_WIDGET_FILTER:
      {
        if ((<Array<number>>state.ids).indexOf(action.payload.widgetId) !== -1) {
          return widgetFiltersAdapter.updateOne({
            id: action.payload.widgetId,
            changes: { loading: true, filter: action.payload.filter }
          }, state);
        }
        return widgetFiltersAdapter.addOne({
          widgetId: action.payload.widgetId,
          loading: true,
          error: null,
          filter: action.payload.filter
        }, state);
      }
    case filterActions.UPDATE_WIDGET_FILTER_COMPLETE:
    case filterActions.LOAD_WIDGET_FILTER_COMPLETE:
    {
      if ((<Array<number>>state.ids).indexOf(action.payload.widgetId) !== -1) {
        return widgetFiltersAdapter.updateOne({
          id: action.payload.widgetId,
          changes: { loading: false, filter: action.payload.filter }
        }, state);
      }
      return widgetFiltersAdapter.addOne({
        widgetId: action.payload.widgetId,
        loading: false,
        error: null,
        filter: action.payload.filter
      }, state);
    }
    case filterActions.UPDATE_WIDGET_FILTER_ERROR:
    case filterActions.LOAD_WIDGET_FILTER_ERROR:
      {
        if ((<Array<number>>state.ids).indexOf(action.payload.widgetId) !== -1) {
          return widgetFiltersAdapter.updateOne({
            id: action.payload.widgetId,
            changes: { loading: false, error: action.error }
          }, state);
        }

        return widgetFiltersAdapter.addOne({
          widgetId: action.payload.widgetId,
          loading: false,
          filter: action.payload.filter,
          error: action.error
        }, state);
      }
    default:
      {
        return state;
      }
  }

}


export class ListTypeFilterInstance extends FilterInstance {
  listTypeId: ListType;
}

export const listTypeFiltersAdapter =
  createEntityAdapter<ListTypeFilterInstance>({selectId:x => x.listTypeId});
export interface ListTypeFilterState extends EntityState<ListTypeFilterInstance> { }
export const INITIAL_LIST_TYPE_FILTER_STATE: ListTypeFilterState = listTypeFiltersAdapter.getInitialState({});

export function listTypeFilterReducer(state: ListTypeFilterState = INITIAL_LIST_TYPE_FILTER_STATE,
                                      action: filterActions.ListTypeFilterActions) {

  switch (action.type) {
    case filterActions.SAVE_LIST_TYPE_FILTER:
    case filterActions.LOAD_LIST_TYPE_FILTER:
    {
      if ((<Array<ListType>>state.ids).indexOf(action.payload.listType) !== -1) {
        return listTypeFiltersAdapter.updateOne({
          id: action.payload.listType,
          changes: {loading: true, filter: action.payload.filter}
        }, state);
      }
      return listTypeFiltersAdapter.addOne({
        listTypeId: action.payload.listType,
        loading: true,
        error: null,
        filter: action.payload.filter
      }, state);
    }
    case filterActions.SAVE_LIST_TYPE_FILTER_COMPLETE:
    case filterActions.LOAD_LIST_TYPE_FILTER_COMPLETE:
    {
      if ((<Array<ListType>>state.ids).indexOf(action.payload.listType) !== -1) {
        return listTypeFiltersAdapter.updateOne({
          id: action.payload.listType,
          changes: { loading: false, filter: action.payload.filter }
        }, state);
      }
      return listTypeFiltersAdapter.addOne({
        listTypeId: action.payload.listType,
        loading: false,
        error: null,
        filter: action.payload.filter
      }, state);
    }
    case filterActions.SAVE_LIST_TYPE_FILTER_ERROR:
    case filterActions.LOAD_LIST_TYPE_FILTER_ERROR:
    {
      if ((<Array<ListType>>state.ids).indexOf(action.payload.listType) !== -1) {
        return listTypeFiltersAdapter.updateOne({
          id: action.payload.listType,
          changes: { loading: false, error: action.error }
        }, state);
      }
      return listTypeFiltersAdapter.addOne({
        listTypeId: action.payload.listType,
        loading: false,
        filter: action.payload.filter,
        error: action.error
      }, state);
    }
    default:
    {
      return state;
    }
  }
}
